import api from '../../services/api';
import Cookies from 'universal-cookie';

const ExportPDF = (competencia, tipo_proces) => {
    const cookies = new Cookies();

    const CPF = cookies.get('ckCPF');

    let DataComp = competencia;
    DataComp = DataComp.replace(/\//g, "-");
    let Tipo = '';

    console.log(tipo_proces)

    if (tipo_proces.trim() === 'Folha Mensal') {
        Tipo = '11'
    } 
    if (tipo_proces.trim() === 'Recisão') {
        Tipo = '42'
    } 
    if (tipo_proces.trim() === 'Adiant. 13º') {
        Tipo = '51'
    }
    if (tipo_proces.trim() === '13º Salário') {
        Tipo = '52'
    }
    if (tipo_proces.trim() === 'Férias') {
        Tipo = '60'
    }
       
        
    console.log(CPF, DataComp, Tipo)
    api.get(`/datasnap/rest/tsm/ExpPDF("${CPF}","${DataComp}","${Tipo}")`)
        .then(resp => {
            console.log(resp.data.result)
            localStorage.setItem('ArqPDF',resp.data.result)
            window.location.href=`http://disnorteagil.no-ip.biz:8090/sistemas/download/${resp.data.result}`
   
    })

}


export default ExportPDF
